import { Flex } from '@chakra-ui/react';

type FormButtonRowProps = {
  children: React.ReactNode;
};

export const FormButtonRow = ({ children }: FormButtonRowProps) => {
  return (
    <Flex gap={4} justifyContent={'end'}>
      {children}
    </Flex>
  );
};
